const Pay = () => import('../views/Pay');
const Pay2 = () => import('../views/Pay2');
const ScanCode = () => import('../views/ScanCode');
const End = () => import('../views/End');


export default [
    {
        path: "/",
        redirect: "/pay"
    },
    {
        path: "/pay",
        name: "Pay",
        component: Pay,
        meta: {
            requiredAuth: true,
            title: "收银台"
        }
    },
    {
        path: "/cashier",
        name: "cashier",
        component: Pay2,
        meta: {
            requiredAuth: true,
            title: "收银台"
        }
    },
    {
        path: "/scancode",
        name: "ScanCode",
        component: ScanCode,
        meta: {
            title: "收款码"
        }
    },
	{
		path:'/end',
		name:'end',
		component: End,
		meta: {
		    title: "活动已结束"
		}
	}
];
